export const titleUnableToSendDetail = `unable to send detail`
export const titleCommentHasBeenSent = `comment has been sent`